import React from 'react'
import ArticleBox from './ArticleBox'
import ArticleLoader from "./ArticleLoader";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Box from '@material-ui/core/Box';
const number = [1, 2, 3, 4, 5, 6];
const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 4
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
    }
};
const ArticleCarouselLos = ({ articles, isPhone, lang, loading }) => {

    try {

        return (
            <div style={{ direction: 'ltr', marginTop: '20px' }}>
                <Carousel responsive={responsive}>
                    {(loading) ? (
                        (number.map((i) => (
                            <div style={{ direction: 'rtl' }}>
                                <Box m={1}>
                                    <ArticleLoader lang={lang} />
                                </Box>
                            </div>
                        )))
                    ) : (
                        (articles.map((article, i) => (
                            <div style={{ direction: 'rtl' }}>
                                <Box m={1}>
                                    <ArticleBox article={article} lang={lang} style={{ width: '100%' }} />
                                </Box>
                            </div>
                        )))
                    )}
                </Carousel>

            </div>
        )

    } catch (e) {
        console.log(e)
        return (
            <h1>{e.stack.split("@")[0]}</h1>
        )
    }

};
export default ArticleCarouselLos;